import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase";

const plans = [
  { name: "Basic", price: 79, description: "Essential features for individuals.", priceId: "price_1T6cE1HHZ1N93iDp52zt07KZ" },
  { name: "Pro", price: 99, description: "Advanced features for professionals.", priceId: "price_1T6cKTHHZ1N93iDpwuZHhAoy" },
  { name: "Family Plan - Basic", price: 119, description: "Essential features for small families.", priceId: "price_1T6cQ6HHZ1N93iDpLkQZNFc4" },
  { name: "Family Plan - Premium", price: 159, description: "All features for large families and premium service.", priceId: "price_1T6cTmHHZ1N93iDpsY3zZAiT" }
];

const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");

export default function SubscriptionPage() {
  const [loadingPlan, setLoadingPlan] = useState<string | null>(null);
  const [error, setError] = useState("");

  const handleChoosePlan = async (plan: typeof plans[0]) => {
    setLoadingPlan(plan.name);
    setError("");
    console.log("handleChoosePlan called", plan);
    try {
      const user = auth.currentUser;
      console.log("auth.currentUser", user);
      if (!user || !user.email) {
        console.error("User not logged in or missing email");
        throw new Error("You must be logged in to subscribe.");
      }
      const result = await createCheckoutSession({
        email: user.email,
        priceId: plan.priceId,
      });
      console.log("createCheckoutSession result", result);
      const data = result.data as { url?: string };
      if (!data?.url) {
        console.error("Stripe did not return a checkout URL", data);
        throw new Error("Stripe did not return a checkout URL.");
      }
      window.location.assign(data.url);
    } catch (err: any) {
      console.error("handleChoosePlan error", err);
      setError(err?.message || "Something went wrong.");
    } finally {
      setLoadingPlan(null);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: "40px auto", padding: 24 }}>
      <h2 style={{ marginBottom: 18 }}>Choose Your Subscription</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        {plans.map(plan => (
          <div key={plan.name} style={{ border: "1px solid #3182ce", borderRadius: 8, padding: 18, background: "#f7fafc" }}>
            <h3 style={{ margin: "0 0 8px 0", color: "#3182ce" }}>{plan.name}</h3>
            <div style={{ fontSize: 22, fontWeight: 600, marginBottom: 6 }}>
              €{plan.price}/month
            </div>
            <div style={{ marginBottom: 12 }}>{plan.description}</div>
            <button
              className="btn btn-primary"
              style={{ width: "100%" }}
              disabled={!!loadingPlan}
              onClick={() => handleChoosePlan(plan)}
            >
              {loadingPlan === plan.name ? "Redirecting..." : `Choose ${plan.name}`}
            </button>
          </div>
        ))}
      </div>
      {error && <div style={{ color: "#e53e3e", marginTop: 18 }}>{error}</div>}
    </div>
  );
}
